module.exports = __webpack_public_path__ + "img/WAX.9491c204.svg";